var map = {
	"./1.svg": "fc2f",
	"./10.svg": "0574",
	"./11.svg": "23a5",
	"./12.svg": "1903",
	"./13.svg": "672a",
	"./14.svg": "5528",
	"./15.svg": "b2bf",
	"./16.svg": "78af",
	"./17.svg": "b9ea",
	"./18.svg": "9a8b",
	"./19.svg": "35ae",
	"./2.svg": "cda0",
	"./20.svg": "75b0",
	"./21.svg": "337d",
	"./22.svg": "82f4",
	"./23.svg": "3264",
	"./24.svg": "fa80",
	"./25.svg": "dc8c",
	"./26.svg": "63a2",
	"./27.svg": "9a45",
	"./28.svg": "b56c",
	"./29.svg": "b779",
	"./3.svg": "843e",
	"./30.svg": "3e8d",
	"./31.svg": "a7ab",
	"./32.svg": "b759",
	"./4.svg": "9d51",
	"./5.svg": "e811",
	"./6.svg": "cdd3",
	"./7.svg": "e9f4",
	"./8.svg": "405b",
	"./9.svg": "81ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "352d";